module.exports = __webpack_public_path__ + "static/screen-classic-mac-laptop-c74a3c7eec982a6a2d1cc20227879738.webp";